if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        evt.stopPropagation();

        if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const formData = new FormData(this.form);
        const variantId = formData.get('id');
        const quantityRaw = formData.get('quantity');
        const quantity = quantityRaw ? parseInt(quantityRaw, 10) || 1 : 1;

        if (!variantId) {
          this.handleErrorMessage('Geen variant geselecteerd.');
          this.resetButtonState();
          return;
        }

        window.mtAddToStorefrontCart(variantId, quantity)
          .then((cart) => {
            this.error = false;

            document.dispatchEvent(
              new CustomEvent('mt-storefront-cart:updated', {
                detail: cart,
              })
            );

            if (window.mtShopifyCart && typeof window.mtShopifyCart.open === 'function') {
              window.mtShopifyCart.open();
              return;
            }

            if (window.mtOpenStorefrontCart && typeof window.mtOpenStorefrontCart === 'function') {
              window.mtOpenStorefrontCart(cart);
              return;
            }

            console.log('Storefront cart updated:', cart);
          })
          .catch((error) => {
            console.error('Storefront add-to-cart error:', error);
            this.error = true;
            this.handleErrorMessage(error.message || 'Toevoegen aan winkelwagen is mislukt.');
          })
          .finally(() => {
            this.resetButtonState();

            if (window.CartPerformance && typeof CartPerformance.measureFromEvent === 'function') {
              CartPerformance.measureFromEvent('add:user-action', evt);
            }
          });
      }

      resetButtonState() {
        if (!this.submitButton) return;

        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.add('hidden');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');

          if (text && this.submitButtonText) {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');

          if (this.submitButtonText && window.variantStrings) {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

/* Modern Treasures Storefront Cart Core */
(function () {
  if (window.mtStorefrontCartLoaded) return;
  window.mtStorefrontCartLoaded = true;

  window.MT_STOREFRONT_DOMAIN = 'nqdkcs-mx.myshopify.com';
  window.MT_STOREFRONT_TOKEN = 'd7ef14b66d218d3f59a6b754bc1fcc99';
  window.MT_STOREFRONT_ENDPOINT =
    'https://' + window.MT_STOREFRONT_DOMAIN + '/api/2026-04/graphql.json';

  window.MT_CART_COOKIE_NAME = 'mt_shopify_storefront_cart_id';

  window.mtSetStorefrontCartId = function (cartId) {
    document.cookie =
      window.MT_CART_COOKIE_NAME +
      '=' +
      encodeURIComponent(cartId) +
      '; domain=.moderntreasures.nl; path=/; max-age=2592000; SameSite=Lax; Secure';
  };

  window.mtGetStorefrontCartId = function () {
    var match = document.cookie.match(new RegExp('(?:^|; )' + window.MT_CART_COOKIE_NAME + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  };

  window.mtClearStorefrontCartId = function () {
    document.cookie =
      window.MT_CART_COOKIE_NAME +
      '=; domain=.moderntreasures.nl; path=/; max-age=0; SameSite=Lax; Secure';
  };

  window.mtStorefrontGraphQL = function (query, variables) {
    return fetch(window.MT_STOREFRONT_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': window.MT_STOREFRONT_TOKEN,
      },
      body: JSON.stringify({
        query: query,
        variables: variables || {},
      }),
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Storefront request failed: ' + response.status);
        }

        return response.json();
      })
      .then(function (json) {
        if (json.errors && json.errors.length) {
          console.error('Storefront GraphQL errors:', json.errors);
          throw new Error(json.errors[0].message || 'Storefront API error');
        }

        return json.data;
      });
  };

  window.mtCartFragment = function () {
    return `
      fragment MtCartFields on Cart {
        id
        checkoutUrl
        totalQuantity
        cost {
          totalAmount {
            amount
            currencyCode
          }
        }
        lines(first: 100) {
          edges {
            node {
              id
              quantity
              cost {
                totalAmount {
                  amount
                  currencyCode
                }
              }
              merchandise {
                ... on ProductVariant {
                  id
                  title
                  image {
                    url
                    altText
                  }
                  selectedOptions {
                    name
                    value
                  }
                  product {
                    title
                    vendor
                    onlineStoreUrl
                  }
                }
              }
            }
          }
        }
      }
    `;
  };

  window.mtCreateStorefrontCart = function (lines) {
    var mutation = `
      ${window.mtCartFragment()}
      mutation MtCartCreate($lines: [CartLineInput!]) {
        cartCreate(input: { lines: $lines }) {
          cart {
            ...MtCartFields
          }
          userErrors {
            field
            message
          }
        }
      }
    `;

    return window
      .mtStorefrontGraphQL(mutation, {
        lines: lines || [],
      })
      .then(function (data) {
        var payload = data.cartCreate;

        if (payload.userErrors && payload.userErrors.length) {
          throw new Error(payload.userErrors[0].message);
        }

        window.mtSetStorefrontCartId(payload.cart.id);

        return payload.cart;
      });
  };

  window.mtFetchStorefrontCart = function (cartId) {
    var query = `
      ${window.mtCartFragment()}
      query MtCart($cartId: ID!) {
        cart(id: $cartId) {
          ...MtCartFields
        }
      }
    `;

    return window
      .mtStorefrontGraphQL(query, {
        cartId: cartId,
      })
      .then(function (data) {
        if (!data.cart) {
          window.mtClearStorefrontCartId();
          return window.mtCreateStorefrontCart([]);
        }

        return data.cart;
      });
  };

  window.mtGetOrCreateStorefrontCart = function () {
    var cartId = window.mtGetStorefrontCartId();

    if (cartId) {
      return window.mtFetchStorefrontCart(cartId).catch(function () {
        window.mtClearStorefrontCartId();
        return window.mtCreateStorefrontCart([]);
      });
    }

    return window.mtCreateStorefrontCart([]);
  };

  window.mtVariantGid = function (variantId) {
    var id = String(variantId || '').trim();

    if (id.indexOf('gid://shopify/ProductVariant/') === 0) {
      return id;
    }

    return 'gid://shopify/ProductVariant/' + id;
  };

  window.mtAddToStorefrontCart = function (variantId, quantity) {
    function add(cartId) {
      var mutation = `
        ${window.mtCartFragment()}
        mutation MtCartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
          cartLinesAdd(cartId: $cartId, lines: $lines) {
            cart {
              ...MtCartFields
            }
            userErrors {
              field
              message
            }
          }
        }
      `;

      return window
        .mtStorefrontGraphQL(mutation, {
          cartId: cartId,
          lines: [
            {
              merchandiseId: window.mtVariantGid(variantId),
              quantity: Number(quantity || 1),
            },
          ],
        })
        .then(function (data) {
          var payload = data.cartLinesAdd;

          if (payload.userErrors && payload.userErrors.length) {
            throw new Error(payload.userErrors[0].message);
          }

          window.mtSetStorefrontCartId(payload.cart.id);

          return payload.cart;
        });
    }

    return window.mtGetOrCreateStorefrontCart().then(function (cart) {
      return add(cart.id);
    });
  };
})();
